import domain from './domain';

// Reset task kanban board
export const resetTaskKanbanBoard = domain.createEvent('resetTaskKanbanBoard');

// Reset task kanban board formatted
export const resetTaskKanbanBoardFormatted = domain.createEvent('resetTaskKanbanBoardFormatted');
